import React from 'react'
import { Form } from 'antd'
import dynamic from 'next/dynamic'
import 'react-quill/dist/quill.snow.css'
import { useTranslation } from 'next-i18next'
import type { ReactQuillProps } from 'react-quill'
import { formats, modules } from './editor.tools'
import { isHtmlTextEmpty } from 'src/core/helpers'
const ReactQuill = dynamic(() => import('react-quill'), { ssr: false })

interface CustomEditorInputProps extends ReactQuillProps {
  required?: boolean,
  name: string,
  placeholder: string
}

const CustomEditorInput: React.FC<CustomEditorInputProps> = (props) => {
  const { name, placeholder, required = false, ...restProps } = props
  const { t } = useTranslation()

  const customValidation = (value: string) => {
    if (!required) {
      return Promise.resolve()
    } else if (!isHtmlTextEmpty(value)) {
      return Promise.resolve()
    } else { return Promise.reject(t('general.RequiredValidation')) }
  }

  return (
    <>
      <Form.Item
        name={name}
        rules={[
          { required, message: t('general.RequiredValidation'), whitespace: true },
          { message: t('general.RequiredValidation'), validator: (_, value) => customValidation(value) }
        ]}
      >
        <ReactQuill
          theme='snow'
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          bounds={'.app'}
          {...restProps}
        />
      </Form.Item>
    </>
  )
}

export default CustomEditorInput
